module.exports = __webpack_public_path__ + "img/clf_qt.ef359cb3.svg";